module.exports = __webpack_public_path__ + "img/thankyouImg.6e3e4691.png";